import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTelegram } from '@/hooks/useTelegram';

const principles = [
  {
    title: 'Рисуй карту, но оставляй белые пятна',
    description: 'Карта — это инструмент, а не готовый мир. Оставляй места для открытий игроков и собственных импровизаций.',
  },
  {
    title: 'Обращайся к персонажам, а не к игрокам',
    description: 'Говори "Фродо, что ты делаешь?", а не "Вася, что делает твой персонаж?"',
  },
  {
    title: 'Принимай решения, опираясь на вымысел',
    description: 'Всё, что происходит в игре, должно иметь смысл в рамках истории. Механика следует за повествованием.',
  },
  {
    title: 'Используй то, что дают тебе игроки',
    description: 'Слушай, что говорят игроки, и используй их идеи. Их предыстории и связи — золотая жила для приключений.',
  },
  {
    title: 'Задавай провокационные вопросы',
    description: '"Кто предал твою семью?" — такие вопросы создают историю и вовлекают игроков в создание мира.',
  },
  {
    title: 'Будь поклонником персонажей',
    description: 'Ты хочешь видеть, как они совершают подвиги. Не будь враждебным мастером — будь их болельщиком.',
  },
  {
    title: 'Думай опасно',
    description: 'Мир полон угроз. Монстры жестоки, ловушки смертельны, а НПС преследуют свои цели.',
  },
  {
    title: 'Начинай и заканчивай вымыслом',
    description: 'Каждый ход начинается с описания ситуации и заканчивается описанием последствий.',
  },
  {
    title: 'Думай за кадром',
    description: 'Мир живёт, даже когда герои не смотрят. Злодеи строят планы, армии маршируют, время идёт.',
  },
];

export function PrinciplesPage() {
  const navigate = useNavigate();
  const { hapticFeedback } = useTelegram();

  return (
    <div className="min-h-screen bg-gray-900 safe-area-top safe-area-bottom">
      {/* Header */}
      <div className="sticky top-0 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 z-10">
        <div className="flex items-center justify-between p-4">
          <button
            onClick={() => {
              hapticFeedback('light');
              navigate('/gm-tools');
            }}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ← Назад
          </button>
          <h1 className="text-lg font-bold text-white">Принципы мастера</h1>
          <div className="w-16" />
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-gray-400 text-sm mb-6"
        >
          Принципы — это руководящие идеи, которые помогают вести игру. Следуй им, и игра будет интересной для всех.
        </motion.p>

        {principles.map((principle, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 * index }}
            className="p-4 rounded-xl bg-gray-800/50 border border-gray-700/50"
          >
            <h3 className="font-medium text-amber-400 mb-2">{principle.title}</h3>
            <p className="text-gray-300 text-sm">{principle.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
